import { useApiPostQuery } from 'mf_core/query';

export function useUjetAuth(enabled: boolean, isUniteChatbot: boolean) {
  return useApiPostQuery<UjetTO>(
    '/ccaip-auth-x4c/v1/access-token',
    { isUnite: isUniteChatbot },
    undefined,
    {
      enabled: enabled,
      queryKey: ['/ccaip-auth-x4c/v1/access-token'],
    }
  );
}

export type UjetTO = {
  configurations: {
    companyId: string;
    companyName: string;
    defaultMenuKey: string | null;
    host: string;
  };
  token: string;
};
